interface SortDirectionInterface {
    ASC: "asc";
    DESC: "desc";
}

interface SortCriteriaInterface {
    INSIGHT: "insight";
    CREATED_AT: "created_at";
    CREATED_BY: "created_by";
}

export const INSIGHT_TABLE_SORT_DIRECTION = <SortDirectionInterface>{
    ASC: "asc",
    DESC: "desc",
};

export const INSIGHT_TABLE_SORT_CRITERIA = <SortCriteriaInterface>{
    INSIGHT: "insight",
    CREATED_AT: "created_at",
    CREATED_BY: "created_by",
};

export const INTERVIEW_LIST_TAB_DIMENSIONS = {
    HEIGHT: 40,
    MIN_HEIGHT: 40,
}

export interface IPresentationLinkTableSortCriteria {
    WEEK: "week",
};

export interface IPresentationLinkTableSortDirection {
    ASC: "asc",
    DESC: "desc",
};

export const PRESENTATION_LINK_TABLE_SORT_CRITERIA = <
    IPresentationLinkTableSortCriteria
>{
    WEEK: "week",
};

export const PRESENTATION_LINK_TABLE_SORT_DIRECTION = <
    IPresentationLinkTableSortDirection
>{
    ASC: "asc",
    DESC: "desc",
};
